import type {
  PerformanceSummary,
  MemberTimelineEntry,
  MemberTableEntry,
  ProjectPerformanceEntry,
} from '../types';

export const mockSummary: PerformanceSummary = {
  totalTasks: 37,
  activeMembersCount: 5,
  averageEfficiency: 123,
  realCost: 33766,
  estimatedCost: 41653,
  deviation: 7887,
};

const WEEK_DATES = [
  '2026-06-23',
  '2026-06-24',
  '2026-06-25',
  '2026-06-26',
  '2026-06-27',
  '2026-06-28',
  '2026-06-29',
];

export const mockTimeline: MemberTimelineEntry[] = [
  {
    memberId: 'member-1',
    memberName: 'Guillermo Emanuel Sandoval Pérez',
    memberAvatarUrl: null,
    schedule: '8:00 a.m. - 6:00 p.m.',
    hourlyRate: 350,
    dailyData: [
      { date: WEEK_DATES[0], efficiency: 79, taskCount: 1 },
      { date: WEEK_DATES[1], efficiency: 93, taskCount: 1 },
      { date: WEEK_DATES[2], efficiency: 79, taskCount: 1 },
      { date: WEEK_DATES[3], efficiency: 80, taskCount: 1 },
      { date: WEEK_DATES[4], efficiency: 88, taskCount: 1 },
      { date: WEEK_DATES[5], efficiency: null, taskCount: 0 },
      { date: WEEK_DATES[6], efficiency: null, taskCount: 0 },
    ],
  },
  {
    memberId: 'member-2',
    memberName: 'Laura Aranda Euan Canché',
    memberAvatarUrl: null,
    schedule: '8:00 a.m. - 6:00 p.m.',
    hourlyRate: 280,
    dailyData: [
      { date: WEEK_DATES[0], efficiency: 68, taskCount: 1 },
      { date: WEEK_DATES[1], efficiency: 79, taskCount: 1 },
      { date: WEEK_DATES[2], efficiency: 75, taskCount: 1 },
      { date: WEEK_DATES[3], efficiency: 90, taskCount: 1 },
      { date: WEEK_DATES[4], efficiency: 74, taskCount: 1 },
      { date: WEEK_DATES[5], efficiency: null, taskCount: 0 },
      { date: WEEK_DATES[6], efficiency: null, taskCount: 0 },
    ],
  },
  {
    memberId: 'member-3',
    memberName: 'Sara Alejandra Martínez Pereira',
    memberAvatarUrl: null,
    schedule: '8:00 a.m. - 6:00 p.m.',
    hourlyRate: 280,
    dailyData: [
      { date: WEEK_DATES[0], efficiency: 71, taskCount: 1 },
      { date: WEEK_DATES[1], efficiency: 80, taskCount: 1 },
      { date: WEEK_DATES[2], efficiency: 79, taskCount: 1 },
      { date: WEEK_DATES[3], efficiency: 67, taskCount: 1 },
      { date: WEEK_DATES[4], efficiency: 90, taskCount: 1 },
      { date: WEEK_DATES[5], efficiency: null, taskCount: 0 },
      { date: WEEK_DATES[6], efficiency: null, taskCount: 0 },
    ],
  },
  {
    memberId: 'member-4',
    memberName: 'Miguel Alejandro Ruiz Torres',
    memberAvatarUrl: null,
    schedule: '8:00 a.m. - 6:00 p.m.',
    hourlyRate: 280,
    dailyData: [
      { date: WEEK_DATES[0], efficiency: 95, taskCount: 1 },
      { date: WEEK_DATES[1], efficiency: 80, taskCount: 1 },
      { date: WEEK_DATES[2], efficiency: 90, taskCount: 1 },
      { date: WEEK_DATES[3], efficiency: 79, taskCount: 1 },
      { date: WEEK_DATES[4], efficiency: 57, taskCount: 1 },
      { date: WEEK_DATES[5], efficiency: null, taskCount: 0 },
      { date: WEEK_DATES[6], efficiency: null, taskCount: 0 },
    ],
  },
  {
    memberId: 'member-5',
    memberName: 'María López Ramírez',
    memberAvatarUrl: null,
    schedule: '8:00 a.m. - 6:00 p.m.',
    hourlyRate: 260,
    dailyData: [
      { date: WEEK_DATES[0], efficiency: 92, taskCount: 1 },
      { date: WEEK_DATES[1], efficiency: 88, taskCount: 1 },
      { date: WEEK_DATES[2], efficiency: 114, taskCount: 1 },
      { date: WEEK_DATES[3], efficiency: 110, taskCount: 1 },
      { date: WEEK_DATES[4], efficiency: 105, taskCount: 1 },
      { date: WEEK_DATES[5], efficiency: null, taskCount: 0 },
      { date: WEEK_DATES[6], efficiency: null, taskCount: 0 },
    ],
  },
];

export const mockTable: MemberTableEntry[] = [
  {
    memberId: 'member-1',
    memberName: 'Guillermo Sandoval',
    memberAvatarUrl: null,
    hourlyRate: 350,
    totalTasks: 8,
    estimatedMinutes: 1800,
    realMinutes: 1345,
    estimatedCost: 10500,
    realCost: 7846,
    gainLoss: 2654,
    efficiency: 134,
  },
  {
    memberId: 'member-2',
    memberName: 'Ana García',
    memberAvatarUrl: null,
    hourlyRate: 280,
    totalTasks: 7,
    estimatedMinutes: 1860,
    realMinutes: 1470,
    estimatedCost: 8680,
    realCost: 6860,
    gainLoss: 1820,
    efficiency: 127,
  },
  {
    memberId: 'member-3',
    memberName: 'Carlos Ruiz',
    memberAvatarUrl: null,
    hourlyRate: 280,
    totalTasks: 7,
    estimatedMinutes: 1760,
    realMinutes: 1415,
    estimatedCost: 8213,
    realCost: 6603,
    gainLoss: 1610,
    efficiency: 124,
  },
  {
    memberId: 'member-4',
    memberName: 'Luis Martínez',
    memberAvatarUrl: null,
    hourlyRate: 250,
    totalTasks: 8,
    estimatedMinutes: 1800,
    realMinutes: 1570,
    estimatedCost: 7500,
    realCost: 6542,
    gainLoss: 958,
    efficiency: 115,
  },
  {
    memberId: 'member-5',
    memberName: 'María López',
    memberAvatarUrl: null,
    hourlyRate: 260,
    totalTasks: 7,
    estimatedMinutes: 1560,
    realMinutes: 1365,
    estimatedCost: 6760,
    realCost: 5915,
    gainLoss: 845,
    efficiency: 114,
  },
];

export const mockProjects: ProjectPerformanceEntry[] = [
  {
    projectId: 'proj-1',
    projectName: 'Plataforma de Análisis',
    memberCount: 3,
    efficiency: 128,
    members: mockTimeline.slice(0, 3),
  },
  {
    projectId: 'proj-2',
    projectName: 'Rediseño Web',
    memberCount: 3,
    efficiency: 119,
    members: mockTimeline.slice(1, 4),
  },
  {
    projectId: 'proj-3',
    projectName: 'App Móvil',
    memberCount: 2,
    efficiency: 110,
    members: mockTimeline.slice(3),
  },
];
